import { gql } from "@apollo/client";

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface CreateResetPasswordEntry {
  username: string;
}

export interface TokenResetPassword {
  token: string;
  password: string;
}
export interface CreateResetResponse {
  createResetPasswordEntry: Def_MutationResponse;
}
export const CREATE_RESET_PASSWORD_ENTRY = gql`
  mutation CreateResetPasswordEntry($username: String!) {
    createResetPasswordEntry(username: $username) {
      code
      success
      message
    }
  }
`;
export interface TokenResetResponse {
  tokenResetPassword: Def_MutationResponse;
}
export const TOKEN_RESET_PASSWORD = gql`
  mutation TokenResetPassword($token: String!, $password: String!) {
    tokenResetPassword(token: $token, password: $password) {
      code
      success
      message
    }
  }
`